import { asyncRoutes } from '@/router'
import store from '@/store'

// 将菜单信息转成对应的路由信息 动态添加
export default function createRoutes(data) {
    const result = []
    const children = []

    result.push({
        path: '/',
        component: () => import('../components/Index.vue'),
        children,
    })

    data.forEach(item => {
        generateRoutes(children, item)
    })

    // 最后添加404页面 否则会在登陆成功后跳到404页面
    result.push(
        { path: '*', redirect: '/404' },
    )

    return result
}

function generateRoutes(children, item) {
    //if (item.name) {
    //    if (asyncRoutes[item.name]) children.push(asyncRoutes[item.name])
    //} else if (item.children) {
    //    item.children.forEach(e => {
    //        generateRoutes(children, e)
    //    })
    //}
    if (item.children && item.children.length>0) {
        item.children.forEach(e => {
            generateRoutes(children, e)
        })
    } else if (item.name) {
        if (asyncRoutes[item.name]){
			children.push({
				path: asyncRoutes[item.name].path,
				name: asyncRoutes[item.name].name,
				meta: asyncRoutes[item.name].meta,
				component: asyncRoutes[item.name].component
			})
			if (asyncRoutes[item.name].children) {
				asyncRoutes[item.name].children.forEach(child => {
					children.push(child);
					store.commit('setSingleMenu', {
						name:child.name,
						text:child.meta.title,
						hidden:true
					});
				})
			}
		}
    }
}
